import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import cx from "classnames";
import { Icon, search, close } from "Icons/index";

import { registerLocale } from "react-datepicker";
import it from "date-fns/locale/it";
registerLocale("it", it);

import "react-datepicker/dist/react-datepicker.css";

//eslint-disable-next-line react/display-name
const CustomInput = forwardRef((props, ref) => {
  const inputClassname = cx(
    [
      "w-52",
      "h-10",
      "text-sm",
      "leading-10",
      "border",
      "border-solid",
      "border-[--input-border]",
      "pr-[1.7rem]",
      "pl-[0.375rem]",
      "rounded",
      "box-border",
      "shadow-none",
      "appearance-none",
      "transition-[border]",
      "duration-[50ms]",
      "ease-in-out",
      "md:h-8",
      "md:leading-8",
      "hover:border-[--input-border-hover]",
      "focus:border-qb-blue",
      "focus:outline-none",
      "cursor-pointer",
      "placeholder:text-sm",
      "placeholder:text-qb-text",
      "placeholder:opacity-50",
      "w-full",
    ],
    {
      ["text-qb-blue"]: props.isActive,
    }
  );

  return (
    <div {...props} ref={ref} className={inputClassname}>
      {props.value}
    </div>
  );
});

const DateRangePicker = ({ label, className, isActive, startDate, endDate, disabled, onChange = () => {} }) => {
  return (
    <div
      className={cx("custom-range-picker flex flex-col", className, {
        ["opacity-50 pointer-events-none"]: disabled,
      })}
    >
      <div className="mb-1 text-sm">{label}</div>
      <DatePicker
        customInput={<CustomInput isActive={isActive} />}
        selected={startDate}
        onChange={(dates) => {
          onChange(dates);
        }}
        openToDate={startDate || new Date()}
        dateFormat={"dd MMM yy"}
        locale="it"
        startDate={startDate}
        endDate={endDate}
        selectsRange
        calendarClassName="z-50 shadow"
        popperClassName="z-50"
        maxDate={new Date()}
      />
    </div>
  );
};

export default DateRangePicker;
